import React from "react";

import { Button, CircularProgress, TableCell, TableRow } from "@mui/material";
import clsx from "clsx";

import mainStyles from "../../../../styles";
import { useTrainingMigrationContext } from "./context/training-migration-provider";

export const TrainingTranslationUpgradeSpreadsheetDownload: React.FC = () => {
  const classes = mainStyles();
  const {
    handleDownloadTranslationUpgradeSpreadsheet,
    isDownloadingSpreadsheet,
  } = useTrainingMigrationContext();
  return (
    <TableRow>
      <TableCell
        className={clsx(
          classes.tableCell,
          classes.leftCell,
          classes.tableLeftColPadding,
        )}
        align="right"
      >
        Download translation upgrade spreadsheet
      </TableCell>
      <TableCell
        className={clsx(
          classes.tableCell,
          classes.leftCell,
          classes.tableRightColPadding,
        )}
        align="left"
        style={{ fontWeight: "normal" }}
      >
        Download a spreadsheet with information on how to get the orgs courses
        ready for translations v2.
      </TableCell>
      <TableCell
        className={clsx(classes.tableCell, classes.rightButtonCell)}
        align="center"
      >
        <Button
          className={clsx(classes.spaceTopSmall, classes.spaceRightMedium)}
          variant="contained"
          color="primary"
          fullWidth
          onClick={handleDownloadTranslationUpgradeSpreadsheet}
          disabled={isDownloadingSpreadsheet}
          startIcon={
            isDownloadingSpreadsheet ? (
              <CircularProgress size={16} color="inherit" />
            ) : undefined
          }
        >
          {isDownloadingSpreadsheet ? "Downloading..." : "Download"}
        </Button>
      </TableCell>
    </TableRow>
  );
};
